import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ApiOutlinedIcon from '@mui/icons-material/ApiOutlined';
import ScreenSearchDesktopOutlinedIcon from '@mui/icons-material/ScreenSearchDesktopOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import IconTile from '../common/IconTile';

// Webflow section_layout308 #1: centered "OCL's open-source toolkit" trio.
const TOOLKIT_ICONS = [ApiOutlinedIcon, ScreenSearchDesktopOutlinedIcon, AccountTreeOutlinedIcon];
const TOOLKIT_ROUTES = ['/tools/terminology-service', '/tools/termbrowser', '/tools/mapper'];

const getToolkit = t =>
  t('home.toolkit.items', { returnObjects: true }).map((item, i) => ({
    ...item,
    icon: TOOLKIT_ICONS[i],
    to: TOOLKIT_ROUTES[i],
  }));

const ToolkitCard = ({ icon, title, text, to }) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
      <IconTile icon={icon} sx={{ mb: 2 }} />
      <Typography variant="h5" component="h3" sx={{ color: 'surface.dark', mb: 1.5 }}>
        {title}
      </Typography>
      <Typography variant="body1" sx={{ color: 'surface.contrastText' }}>
        {text}
      </Typography>
      <Button
        component={RouterLink}
        to={to}
        endIcon={<ArrowForwardIosIcon sx={{ fontSize: '12px !important' }} />}
        sx={{ color: 'primary.main', mt: 2, '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' } }}>
        {t('common.learn_more')}
      </Button>
    </Box>
  );
};

const ToolkitCards = () => {
  const { t } = useTranslation();
  return (
    <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
      <Box sx={{ textAlign: 'center', maxWidth: 640, mx: 'auto', mb: { xs: 5, md: 8 } }}>
        <Typography sx={{ color: 'primary.main', fontWeight: 600, mb: 1 }}>
          {t('home.toolkit.eyebrow')}
        </Typography>
        <Typography variant="h3" component="h2" sx={{ color: 'surface.dark', fontSize: { xs: '2rem', md: '2.5rem' }, mb: 1 }}>
          {t('home.toolkit.heading')}
        </Typography>
        <Typography sx={{ color: 'surface.contrastText' }}>
          {t('home.toolkit.text')}
        </Typography>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: { xs: 5, md: 6 } }}>
        {getToolkit(t).map(tool => <ToolkitCard key={tool.title} {...tool} />)}
      </Box>
    </Container>
  );
};

export default ToolkitCards;
